<template>
  <button
    type="button"
    :aria-label="$t('notifications.openLabel')"
    :aria-haspopup="'dialog'"
    class="relative inline-flex h-8 w-8 items-center justify-center rounded-md border border-border bg-background text-gray-500 transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    @click="onClick"
  >
    <SvgIcon name="sli-bell" class="h-4 w-4 fill-none" />

    <i
      v-if="hasUnread"
      class="pointer-events-none absolute right-1 top-1 inline-block h-2 w-2 rounded-full bg-red-500 ring-2 ring-background"
      aria-hidden="true"
    />
  </button>
</template>

<script setup>
import { computed, inject, onMounted } from "vue";
import { SvgIcon } from "@/shared/ui/svg-icon";
import { useNotificationStore } from "@/entities/notification";
import { storeToRefs } from "pinia";
import { NOTIFICATIONS_DRAWER_KEY } from "@/widgets/notifications-drawer/keys";

const drawer = inject(NOTIFICATIONS_DRAWER_KEY, null);

const store = useNotificationStore();
const { unread } = storeToRefs(store);

const hasUnread = computed(() => (unread.value || 0) > 0);

onMounted(() => {
  store.fetchCounter();
});

function onClick() {
  if (drawer?.open) drawer.open();
}
</script>
